/**
 * Format an ISO timestamp as a locale date-time string, echoing the raw input
 * back when it can't be parsed. Shared by the order table and the tracking
 * details modal.
 */
export function formatDateTime(dateStr: string): string {
  const date = new Date(dateStr);
  return Number.isNaN(date.getTime()) ? dateStr : date.toLocaleString();
}
